import React, { useState, useEffect } from 'react';
import './supplier.css';
import { FaHandshake, FaMedal } from 'react-icons/fa';

function Supplier() {
  // Supplier data with logos and details
  const suppliers = [

        {
              
      id: 1,
      name: "SINETH",
      logo: "/suppliers/sineth.png",
    },
    {
      id: 2,
      name: "VISION 2020 TECHNO",
      logo: "/suppliers/vision2020.png",
    },

        {
      id: 3,
      name: "OPTO TECH",
      logo: "/suppliers/opto.png",
    },

    {
      id: 4,
      name: "BRIGHT VISION OPTICAL",
      logo: "/suppliers/bright.jpeg",
    },
    {
      id: 5,
      name: "HANDSOME OPTICAL",
      logo: "/suppliers/handsomeoptical.jpeg",
    },



  ];

  // State for animated counting
  const [counts, setCounts] = useState({
    locations: 0,
    years: 0,
    equipment: 0
  });

  // Target values
  const targetCounts = {
    locations: 50,
    years: 15,
    equipment: 100
  };

  // Animated counting effect
  useEffect(() => {
    const duration = 2000; // 2 seconds
    const steps = 60;
    const interval = duration / steps;

    let currentStep = 0;
    const timer = setInterval(() => {
      currentStep++;
      const progress = currentStep / steps;
      
      setCounts({
        locations: Math.min(Math.floor(progress * targetCounts.locations), targetCounts.locations),
        years: Math.min(Math.floor(progress * targetCounts.years), targetCounts.years),
        equipment: Math.min(Math.floor(progress * targetCounts.equipment), targetCounts.equipment)
      });

      if (currentStep >= steps) {
        clearInterval(timer);
      }
    }, interval);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="supplier-page">
      {/* Hero Section */}
      <section className="supplier-hero-section">
        <div className="supplier-hero-content-wrap">
          <h1 className="supplier-hero-title">
            Our <span>Trusted Suppliers</span>
          </h1>
          <p className="supplier-hero-description">
            We partner with world-class suppliers who share our commitment to quality, innovation, and sustainability.
            Together, we deliver exceptional value to our clients across the globe.
          </p>
        </div>
      </section>

      {/* Count Stats Section */}
<section className="supplier-stats-section">
  <div className="supplier-container-custom">
    <div className="supplier-stats-grid">

      <div className="supplier-stat-item">
        <div className="supplier-stat-number">
          {counts.locations}+
        </div>
        <div className="supplier-stat-label">
          Locations Islandwide
        </div>
      </div>

      <div className="supplier-stat-item">
        <div className="supplier-stat-number">
          {counts.years}+
        </div>
        <div className="supplier-stat-label">
          Years of Excellence
        </div>
      </div>

      <div className="supplier-stat-item">
        <div className="supplier-stat-number">
          {counts.equipment}+
        </div>
        <div className="supplier-stat-label">
          Equipment Supplied
        </div>
      </div>

    </div>
  </div>
</section>

      {/* Suppliers Grid */}
      <section className="supplier-grid-section">
        <div className="supplier-container-custom">
          <h2 className="supplier-section-title">Our Suppliers</h2>
          <br />
          <div className="supplier-grid-container">
            {suppliers.map((supplier) => (
              <div key={supplier.id} className="supplier-card-item">
                <div className="supplier-logo-box">
                  <img 
                    src={supplier.logo} 
                    alt={`${supplier.name} logo`}
                    className="supplier-logo-image"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = 'https://via.placeholder.com/300x200/333333/ffffff?text=' + supplier.name.charAt(0);
                    }}
                  />
                </div>

              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Join Section */}
      <section className="supplier-join-section">
        <div className="supplier-container-custom">
          <div className="supplier-join-content">
            <div className="supplier-join-left">
              <h2>Become a <span>Supplier</span></h2>
              <p>
                Are you a supplier who shares our values of quality, innovation, and integrity?
                Join our network of trusted partners and grow your business with Optica International.
              </p>
            
            </div>
            <div className="supplier-join-right">
              <div className="supplier-join-feature">
                <FaMedal className="supplier-feature-icon" />
                <h4>Quality Assurance</h4>
                <p>Rigorous quality standards ensure excellence</p>
              </div>
              <div className="supplier-join-feature">
                <FaHandshake className="supplier-feature-icon" />
                <h4>Fair Partnerships</h4>
                <p>Transparent and mutually beneficial relationships</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Supplier;